<script>

/**
 * Automodal 
 * 
 * Version 1.4
 * Agrega el concepto haldeItem, que permite manipular los elementos del archetyipo independientemeente 
 * de si son arreglos de objetos o solo objetos.
 * 
 * Version 1.3
 * Remvue el concepto de archetype como prpoiedad por causar conflictos
 * Recomendado switch por item.key en cArchetype para evitar errores de ejecución.
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import md5 from 'js-md5'

import {archetype, automodalHandler} from './archetype'

export default {
    name: 'automodal',
    props: {
        elementoId: {
            type: [String, Number],
        },
        tipo: {
            type: [String, Number],
            default: '1'
        },
        conceptId: {
            type: [String, Number],
        }
    },
    data: () => {
        return {
            form: {
                id_pk: null
            },
            asides: {
                ingredientes: [],
                proveedores: [],
                marcas: [],
                unidadesMedicion: [],
                tiposPresentacion: [],
            }
        }
    },
    computed: {
        formArchetypeMD5(){
			return md5(JSON.stringify(this.cArchetype))
		},
        cArchetype(){
            let updated = [];
            _.forEach(archetype, itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(this.handleItem(itemsRow));
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    adding.push(this.handleItem(item))
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        handleItem(item){
            // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
            if(_.isObjectLike(item)){
                switch(item.key){
                    case 'elemento_id_fk':
                        switch(parseInt(this.tipo)){
                            case 1:
                                item.label = 'Ingrediente';
                                break;
                            case 2:
                                item.label = 'Artículo';
                                break;
                        }
                        if(this.elementoId && !this.form.id_pk) {
                            item.default    = this.elementoId
                            item.options    = [{
                                value: this.elementoId,
                                text: '-- Nueva presentación --'
                            }]
                        } else {
                            item.options    = _.clone(this.asides.ingredientes)
                        }
                        break;
                    case 'idmarca_fk':
                        item.options = _.clone(this.asides.marcas)
                        break;
                    case 'proveedor_asignado_id':
                        item.options = _.clone(this.asides.proveedores)
                        break;
                    case 'idunidad_fk':
                        item.options = _.clone(this.asides.unidadesMedicion)
                        break;
                    case 'tipopresentacion':
                        item.options = _.clone(this.asides.tiposPresentacion)
                        break;
                    // case 'distribuidores_id':
                        // item.options = _.clone(this.asides.distribuidores)
                        // break;
                }
            }
            return item;
        },
        getHandler(){
            return automodalHandler(this.conceptId, this.tipo)
        },
        refresh(){
            this.$emit('refresh');
        },
        checkAsides(){
            const asides = this.$refs.automodal.getAsides();
            if(!!asides){
                _.forEach(this.asides, (kValue, kName) => {
                    console.log('kValue', kValue, kName, asides)
                    this.asides[kName] = asides[kName]
                })
            }
        },
        onDisplay(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },
        onHidden(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        },

    },
    watch: {
        'form.id'(){
            
        }
    }
}
</script>

<template>
    <div>
        <ui-edit-auto-modal v-model="form"  ref="automodal" size="md" 
        	:form-id="form.id_pk" 
        	:form-archetype="cArchetype" 
        	:handler="getHandler()"  
        	:allow-aside="false" 
        	:allow-delete="true"
            :form-key="formArchetypeMD5"
        	@refresh="refresh()" 
        	@defined="checkAsides()" 
        	@display="onDisplay" 
    		@hidden="onHidden">
            <slot name="default"><i class="fa fa-cog"></i></slot>
            <b-col slot="aside" cols="7">
                <!-- LATERAL, REQUIERE :allow-aside="true" -->
            </b-col>
            <b-col slot="bottom">
                <b-row>
					<b-col>
						<!-- visible_en_tienda -->
						<b-form-checkbox v-model="form.visible_en_tienda" name="check-button" value="1" unchecked-value="0"
							switch>
							<span v-if="form.visible_en_tienda == '1'">Disponible en tienda</span>
							<span v-else>Oculto la tienda</span>
						</b-form-checkbox>
						<!-- visible_en_tienda -->
					</b-col>
				</b-row>

				<b-row class="ml-1" v-if="form.visible_en_tienda == '1'">
					<b-col>
						<b-form-checkbox v-model="form.visible_en_zero" name="check-button" value="1" unchecked-value="0"
							switch>
							<span v-if="form.visible_en_zero == '1'">Disponible en inventario 0</span>
							<span v-else>Oculto en inventario 0</span>
						</b-form-checkbox>
						<b-form-checkbox v-model="form.promocionado_en_tienda" name="check-button" value="1"
							unchecked-value="0" switch>
							<span v-if="form.promocionado_en_tienda == '1'">Promocionado</span>
							<span v-else>Promover en la tienda</span>
						</b-form-checkbox>
						<b-form-checkbox v-model="form.promocionado_en_categoria" name="check-button" value="1"
							unchecked-value="0" switch>
							<span v-if="form.promocionado_en_categoria == '1'">Promocionado en su categoría</span>
							<span v-else>Promover en su categoria</span>
						</b-form-checkbox>
					</b-col>
				</b-row>
            </b-col>
        </ui-edit-auto-modal>
    </div>
</template>